module.exports = __webpack_public_path__ + "static/js/0.ac7d418c.chunk.worker.js"